let env = {};
env.baseURL = 'http://localhost:8000/api/v1/';
env.normalURL = 'http://localhost:8000/';
export default env


//////////////////
// WEBPACK FOOTER
// ./config/env
// module id = null
// module chunks = 